var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"clearable":"","flat":"","disabled":_vm.disabled,"item-text":_vm.itemText,"item-value":_vm.itemValue,"label":_vm.label,"required":"","items":_vm.items,"rules":_vm.rules,"validate-on-blur":"","chips":_vm.chips,"multiple":_vm.multiple},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }